module.exports = __webpack_public_path__ + "static/media/gryphon_x_ids_imagecollage.5e0b8661.png";